import React, { useEffect, useState } from 'react';
import { AnalyticalTable } from '@ui5/webcomponents-react';
import axiosInstance from '../utils/axiosInstance'; // Asegúrate de importar axiosInstance

const Historic = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true); // Estado para el sidebar

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get('packing-lists'); // Ajusta la URL según tu API
        if (response.data.code === 'SUCCESS') {
          setData(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError('Error fetching historic data');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const columns = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Nombre', accessor: 'name' },
    { Header: 'Fecha', accessor: 'date' },
    { Header: 'Estado', accessor: 'status' },
    // Agrega más columnas según sea necesario
  ];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div style={{ width: '100%', padding: '0' }}>
      <h1>Histórico</h1>
      <AnalyticalTable
        data={data}
        columns={columns}
        visibleRows={5}
        minRows={5}
        scaleWidthMode="Smart"
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default Historic;
